// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 328 ? "admin" : chunkId) + "." + {"35":"ef3bfb25","328":"7c7c047d","485":"739e6d45"}[chunkId] + ".css";
};